/**
 * Pure helper — filters the Help-menu training-video list by per-video access
 * gates (#137).
 *
 * Background: most training videos are visible to everyone. A handful are
 * gated to a specific feature-access flag — currently `timeTravelAccess`,
 * which mirrors the User Manual's Time Travel chapter access gate
 * (`canAccessTimeMachine`). Users without the access flag must not see the
 * entry exists.
 *
 * Convention: a video entry carries `requiresTimeTravelAccess: true` to opt
 * into the gate. Entries without the flag (or with it set to false) are
 * always visible.
 *
 * If the gate set grows beyond `timeTravelAccess`, the function signature
 * can extend to take an object of access flags. For now keep the API
 * minimal — only one gate exists.
 *
 * @param {Array<object>} videos              entries from SCHEDULER_VIDEOS / FLOORING_XP_VIDEOS
 * @param {boolean} hasTimeTravelAccess       result of `canAccessTimeMachine(...)`
 * @returns {Array<object>}                   filtered array; returns a NEW array
 */
export function filterVideosByAccess(videos, hasTimeTravelAccess) {
  if (!Array.isArray(videos)) return [];
  return videos.filter((video) => {
    if (video == null || typeof video !== "object") return false;
    if (video.requiresTimeTravelAccess === true) {
      return hasTimeTravelAccess === true;
    }
    return true;
  });
}
